import { statusCodes } from "../utilities/constants";
import { getAppName } from "../utilities/getAppName";

const getTerms = async (storeGroupRef) => {
  try {
    const snapshot = await storeGroupRef.get();
    if (snapshot.exists) {
      const _onboarding = snapshot.data().content?.sv?.onboarding
      const onboarding = typeof _onboarding === 'string' ? _onboarding : "";
      return onboarding;
    }
  } catch (error) {
    console.error("Could not fetch terms. ", error);
  }
  return "";
};

export const decisionResponses = {
  [statusCodes[400].code]: {
    response: {
      heading: "Din ansökan har ej godkänts",
      text: `Du uppfyller i dagsläget inte kriterierna för att bli medlem hos ${getAppName()}. Du är välkommen att ansöka igen längre fram om dina förutsättningar förändras.`,
    },
    reasons: [
      {
        label: "Hög Inkomst",
        heading: "För hög inkomst",
        text: "För att bli medlem har vi ett inkomsttak på 13.717 kronor efter skatt.",
      },
      {
        label: "Ukraina, ej LMA-kort",
        heading: "Från Ukraina, har inte LMA-kort",
        text: "Bara personer med svenskt personnummer söka medlemskap digitalt. Besök oss i våra butiker så hjälper vi dig personligen. Se tider i appen för hjälp med medlemskap.",
      },
      {
        label: "Redan medlem",
        heading: "Har redan aktivt medlemskap",
        text: "Har redan aktivt medlemskap, var snäll och kom in med ditt pappersmedlemskort.",
      },
      {
        label: "CSN",
        heading: "CSN",
        text: "Personer med studiestöd kan inte bli medlemmar. För vidare stöd, se följande länk https://www.stadsmissionen.se/matmissionen/avslag",
      },
      {
        label: "Föräldrapenning",
        heading: "Föräldrapenning",
        text: "Besök oss i våra butiker så hjälper vi dig personligen, digital bedömning kan inte göras gällande föräldrapenning. Se tider i appen för hjälp med medlemskap.",
      },
      {
        label: "Fel 3 ggr",
        heading: "Har skickat in fel dokument tre gånger",
        text: "Besök oss i våra butiker. Se tider i appen för hjälp med medlemskap.",
      }
    ],
  },
  [statusCodes[500].code]: {
    response: {
      heading: "Din ansökan var ej komplett",
      text: "Vänligen komplettera din ansökan och skicka in på nytt.",
    },
    reasons: [
      {
        label: "ID",
        heading: "Bilden på din ID-handling var otydlig",
        text: "Du behöver därför ladda upp bild på din ID-handling samt selfie på nytt.",
      },
      {
        label: "Selfie",
        heading: "Din selfie var otydlig",
        text: "Du behöver därför ladda upp bild på din ID-handling samt selfie på nytt.",
      },
      {
        label: "Intyg",
        heading: "Syns inte vem intyget tillhör",
        text: "Komplettera med intyg på inkomst där vi ser vem det tillhör.",
      },
      {
        label: "Inkomst",
        heading: "Skickat fel inkomstpapper eller inte inkomst alls",
        text: "Komplettera med intyg på inkomst för senaste månaderna där man ser inkomstbelopp per månad, var inkomsten kommer från och vem intyget tillhör. Om ingen inkomst finns – ",
      },
      {
        label: "Allt",
        heading: "Allt saknas",
        text: "Komplettera med foto på din ID-handling, selfie på dig och intyg på inkomst för senaste månaderna där man ser inkomstbelopp per månad, var inkomsten kommer från och vem intyget tillhör.",
      },
      {
        label: "ID+Selfie",
        heading: "Bilden på din ID-handling och din selfie var otydliga",
        text: "Du behöver ladda upp bild på din ID-handling samt selfie på nytt.",
      },
      {
        label: "ID+Inkomst",
        heading: "ID-handling och inkomst saknas",
        text: "Komplettera med foto på din ID-handling och intyg på inkomst för senaste månaderna där man ser inkomstbelopp per månad, var inkomsten kommer från och vem intyget tillhör. Om ingen inkomst finns – ",
      },
      {
        label: "Selfie+Inkomst",
        heading: "Selfie och inkomst saknas",
        text: "Komplettera med ny selfie på dig och intyg på inkomst för senaste månaderna där man ser inkomstbelopp per månad, var inkomsten kommer från och vem intyget tillhör. Om ingen inkomst finns – ",
      },
    ],
  },
  [statusCodes[600].code]: {
    response: {
      heading: "Din ansökan har godkänts",
      text: `Ditt medlemskap i ${getAppName()} kommer aktiveras inom kort.`,
      extra: getTerms,
    },
  },
};

